export type CardTemplate = {
  id: string
  label: string
  description: string
  previewClass: string
  pageClass: string
  heroGradient: (r: number, g: number, b: number) => string
}

export const cardTemplates: CardTemplate[] = [
  {
    id: "clean",
    label: "נקי",
    description: "מראה בהיר ומסודר שמתאים לכל עסק",
    previewClass: "bg-gradient-to-br from-teal-500 to-sky-500",
    pageClass: "card-template-clean",
    heroGradient: (r, g, b) => `linear-gradient(180deg, rgba(${r} ${g} ${b} / 0.96) 0%, rgba(15, 23, 42, 0.92) 70%, rgba(2, 6, 23, 1) 100%)`,
  },
  {
    id: "warm",
    label: "חם",
    description: "צבעים רכים ואווירה מזמינה",
    previewClass: "bg-gradient-to-br from-orange-400 to-rose-500",
    pageClass: "card-template-warm",
    heroGradient: (r, g, b) => `linear-gradient(180deg, rgba(${r} ${g} ${b} / 0.96) 0%, rgba(${r} ${g} ${b} / 0.62) 42%, rgba(67, 20, 7, 1) 100%)`,
  },
  {
    id: "dark",
    label: "כהה",
    description: "מראה דרמטי ובולט",
    previewClass: "bg-gradient-to-br from-slate-700 to-slate-950",
    pageClass: "card-template-dark",
    heroGradient: (r, g, b) => `linear-gradient(180deg, rgba(${r} ${g} ${b} / 0.85) 0%, rgba(15, 23, 42, 0.98) 72%, rgba(2, 6, 23, 1) 100%)`,
  },
  {
    id: "editorial",
    label: "קלאסי",
    description: "מראה אלגנטי עם תחושה של מגזין",
    previewClass: "bg-gradient-to-br from-stone-400 to-amber-900",
    pageClass: "card-template-editorial",
    heroGradient: (r, g, b) => `linear-gradient(180deg, rgba(${r} ${g} ${b} / 0.92) 0%, rgba(${r} ${g} ${b} / 0.5) 42%, rgba(28, 25, 23, 1) 100%)`,
  },
  {
    id: "bold",
    label: "מודרני",
    description: "מבנה חד ובולט שמוביל לפעולה",
    previewClass: "bg-gradient-to-br from-fuchsia-500 to-indigo-700",
    pageClass: "card-template-bold",
    heroGradient: (r, g, b) => `linear-gradient(135deg, rgba(${r} ${g} ${b} / 0.98) 0%, #312e81 100%)`,
  },
]

export function getCardTemplate(id: string) {
  return cardTemplates.find((template) => template.id === id) || cardTemplates[0]
}
